// src/api.js — cliente HTTP para cyker-api (reemplaza firebase-config.js)

const BASE_URL = 'https://cyker.satelitax.com.ar/api';

export const getToken = () => localStorage.getItem('cyker_admin_token');
export const setToken = (token) => localStorage.setItem('cyker_admin_token', token);
export const removeToken = () => localStorage.removeItem('cyker_admin_token');

const apiFetch = async (path, options = {}) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  };

  const response = await fetch(`${BASE_URL}${path}`, { ...options, headers });

  if (response.status === 401) {
    if (getToken()) {
      removeToken();
      window.location.hash = '#/login';
    }
    throw new Error('No autorizado');
  }

  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Error desconocido' }));
    throw new Error(err.error || err.message || 'Error en la solicitud');
  }

  return response.json();
};

export const api = {
  get:    (path)        => apiFetch(path),
  post:   (path, body)  => apiFetch(path, { method: 'POST',   body: JSON.stringify(body) }),
  put:    (path, body)  => apiFetch(path, { method: 'PUT',    body: JSON.stringify(body) }),
  delete: (path)        => apiFetch(path, { method: 'DELETE' }),
};
